var tiktok = "//s3.amazonaws.com/edge-assets.lemonade.com/tiktok-07abe2bb630f815692c89ba65afc847b.svg";

export { tiktok as default };
